@for (tab of tabs; track tab) {
  <ng-container *ngIf="isIconTab(tab)">
    <app-x-tab-segment [active]="tab.id === active" [disabled]="tab.disabled" (click)="onTabClick(tab)" [icon]="tab.icon"></app-x-tab-segment>
  </ng-container>

  <ng-container *ngIf="isTextTab(tab)">
    <app-x-tab-segment [active]="tab.id === active" [disabled]="tab.disabled" (click)="onTabClick(tab)">{{ tab.title }}</app-x-tab-segment>
  </ng-container>
}
